// Auto-generated from maptoposter/themes/*.json
// All 30 Piggery Studio themes

const THEMES = {
  amber_canopy: {
    id: "amber_canopy",
    available: false,
    name: "Amber Canopy",
    description: "Burnt oranges, deep reds, golden yellows - seasonal warmth",
    bg: "#FBF7F0", text: "#8B4513", gradient_color: "#FBF7F0",
    water: "#D8CFC0", parks: "#E8E0D0", buildings: "#E0D8C8",
    road_motorway: "#8B2500", road_primary: "#B8450A",
    road_secondary: "#CC7A30", road_tertiary: "#D9A050",
    road_residential: "#E8C888"
  },
  architect_draft: {
    id: "architect_draft",
    name: "Architect Draft",
    description: "Classic architectural drafting - technical drawing aesthetic",
    bg: "#1A3A5C", text: "#E8F4FF", gradient_color: "#1A3A5C",
    water: "#0F2840", parks: "#1E4570", buildings: "#224A70",
    road_motorway: "#E8F4FF", road_primary: "#C5DCF0",
    road_secondary: "#9FC5E8", road_tertiary: "#7BAED4",
    road_residential: "#5A96C0"
  },
  city_grid: {
    available: false,
    id: "city_grid",
    name: "City Grid",
    description: "Classic architectural blueprint - crisp technical drawing aesthetic",
    bg: "#122A45", text: "#F5FAFF", gradient_color: "#1E4570",
    water: "#081A2F", parks: "#204A78", buildings: "#1A4068",
    road_motorway: "#F5FAFF", road_primary: "#D5E6F5",
    road_secondary: "#AACBE8", road_tertiary: "#7FAED4",
    road_residential: "#5C8FBF"
  },
  clay_horizon: {
    available: false,
    id: "clay_horizon",
    name: "Clay Horizon",
    description: "Mediterranean warmth - burnt orange and clay tones on cream",
    bg: "#F5EDE4", text: "#8B4513", gradient_color: "#F5EDE4",
    water: "#A8C4C4", parks: "#E8E0D0", buildings: "#E0D8C8",
    road_motorway: "#A0522D", road_primary: "#B8653A",
    road_secondary: "#C9846A", road_tertiary: "#D9A08A",
    road_residential: "#E5C4B0"
  },
  cobalt_monoline: {
    id: "cobalt_monoline",
    name: "Cobalt Monoline",
    description: "Single blue color family with varying saturation - clean and cohesive",
    bg: "#F5F8FA", text: "#1A3A5C", gradient_color: "#F5F8FA",
    water: "#D0E0F0", parks: "#E0EAF2", buildings: "#D8E4EC",
    road_motorway: "#1A3A5C", road_primary: "#2A5580",
    road_secondary: "#4A7AA8", road_tertiary: "#7AA0C8",
    road_residential: "#A8C4E0"
  },
  deep_nightfall: {
    id: "deep_nightfall",
    name: "Deep Nightfall",
    description: "Deep navy background with gold/copper roads - luxury atlas aesthetic",
    bg: "#0A1628", text: "#D4AF37", gradient_color: "#0A1628",
    water: "#061020", parks: "#0F2235", buildings: "#152A40",
    road_motorway: "#D4AF37", road_primary: "#C9A227",
    road_secondary: "#A8893A", road_tertiary: "#8B7355",
    road_residential: "#6B5B4F"
  },
  dusk_ember: {
    id: "dusk_ember",
    name: "Dusk Ember",
    description: "Warm oranges and pinks on soft peach - dreamy golden hour aesthetic",
    bg: "#FDF5F0", text: "#C45C3E", gradient_color: "#FDF5F0",
    water: "#F0D8D0", parks: "#F8E8E0", buildings: "#F5E0D8",
    road_motorway: "#C45C3E", road_primary: "#D87A5A",
    road_secondary: "#E8A088", road_tertiary: "#F0B8A8",
    road_residential: "#F5D0C8"
  },
  electric_horizon: {
    id: "electric_horizon",
    name: "Electric Horizon",
    description: "Deep midnight with balanced neon cyan/magenta - bold cyber city aesthetic",
    bg: "#070713", text: "#7CF9FF", gradient_color: "#0B0B18",
    water: "#060611", parks: "#101024", buildings: "#181830",
    road_motorway: "#FF4DFF", road_primary: "#39FFFF",
    road_secondary: "#19D1D1", road_tertiary: "#0FA0A8",
    road_residential: "#0A6E75"
  },
  forest_moss: {
    id: "forest_moss",
    name: "Forest Moss",
    description: "Deep forest green and cream - nature inspired for rural and woodland towns",
    bg: "#F5F3F0", text: "#2D4A3E", gradient_color: "#F5F3F0",
    water: "#A8C4B8", parks: "#C8D8C8", buildings: "#D8E0D8",
    road_motorway: "#2D4A3E", road_primary: "#4A6B5A",
    road_secondary: "#6B8B78", road_tertiary: "#8CA898",
    road_residential: "#B0C4B8"
  },
  gallery_ink: {
    id: "gallery_ink",
    name: "Gallery Ink",
    description: "Black-on-ivory fine-line minimalism - museum / design studio look",
    bg: "#FAFAF7", text: "#111111", gradient_color: "#FAFAF7",
    water: "#DDE6EE", parks: "#E7EFE7", buildings: "#E5E5E5",
    road_motorway: "#111111", road_primary: "#2A2A2A",
    road_secondary: "#444444", road_tertiary: "#606060",
    road_residential: "#7A7A7A"
  },
  heritage_gold: {
    available: false,
    id: "heritage_gold",
    name: "Heritage Gold",
    description: "Ivory and antique gold - elegant wedding and anniversary keepsake",
    bg: "#FDFCF8", text: "#8B7355", gradient_color: "#FDFCF8",
    water: "#E8E0D5", parks: "#F0EBE3", buildings: "#E8E4DA",
    road_motorway: "#8B7355", road_primary: "#A08060",
    road_secondary: "#B89570", road_tertiary: "#D0B088",
    road_residential: "#E0C8A0"
  },
  industrial_raw: {
    available: false,
    id: "industrial_raw",
    name: "Industrial Raw",
    description: "Concrete grey and rust orange - urban edge for modern loft spaces",
    bg: "#E8E4E0", text: "#3D3530", gradient_color: "#E8E4E0",
    water: "#B8C4C0", parks: "#C8D0C8", buildings: "#D8D4D0",
    road_motorway: "#3D3530", road_primary: "#5A5048",
    road_secondary: "#787068", road_tertiary: "#989088",
    road_residential: "#B8B0A8"
  },
  jade_orbit: {
    id: "jade_orbit",
    name: "Jade Orbit",
    description: "Lush dark green aesthetic with mint accents",
    bg: "#062C22", text: "#E3F9F1", gradient_color: "#062C22",
    water: "#0D4536", parks: "#0F523E", buildings: "#0A382C",
    road_motorway: "#4ADEB0", road_primary: "#2DB88F",
    road_secondary: "#249673", road_tertiary: "#1B7559",
    road_residential: "#155C46"
  },
  landmark_layers: {
    available: false,
    id: "landmark_layers",
    name: "Landmark Layers",
    description: "Different shades for different road types - clear hierarchy",
    bg: "#FFFFFF", text: "#000000", gradient_color: "#FFFFFF",
    water: "#C0C0C0", parks: "#F0F0F0", buildings: "#E0E0E0",
    road_motorway: "#0A0A0A", road_primary: "#1A1A1A",
    road_secondary: "#2A2A2A", road_tertiary: "#3A3A3A",
    road_residential: "#4A4A4A"
  },
  midnight_ink: {
    available: false,
    id: "midnight_ink",
    name: "Midnight Ink",
    description: "Pure black background with white/gray roads - modern gallery aesthetic",
    bg: "#000000", text: "#FFFFFF", gradient_color: "#000000",
    water: "#0A0A0A", parks: "#111111", buildings: "#1A1A1A",
    road_motorway: "#FFFFFF", road_primary: "#E0E0E0",
    road_secondary: "#B0B0B0", road_tertiary: "#808080",
    road_residential: "#505050"
  },
  neon_circuit: {
    id: "neon_circuit",
    name: "Neon Circuit",
    description: "Dark background with electric pink/cyan - bold night city vibes",
    bg: "#0D0D1A", text: "#00FFFF", gradient_color: "#0D0D1A",
    water: "#0A0A15", parks: "#151525", buildings: "#202035",
    road_motorway: "#FF00FF", road_primary: "#00FFFF",
    road_secondary: "#00C8C8", road_tertiary: "#0098A0",
    road_residential: "#006870"
  },
  nordic_frost: {
    available: false,
    id: "nordic_frost",
    name: "Nordic Frost",
    description: "Scandinavian minimalism - pale greys with muted icy blue accents",
    bg: "#F5F7F9", text: "#4A5568", gradient_color: "#F5F7F9",
    water: "#D4E1E8", parks: "#E8EDF0", buildings: "#E0E6E8",
    road_motorway: "#4A5568", road_primary: "#718096",
    road_secondary: "#A0AEC0", road_tertiary: "#CBD5E0",
    road_residential: "#E2E8F0"
  },
  oxidised_glow: {
    available: false,
    id: "oxidised_glow",
    name: "Oxidised Glow",
    description: "Oxidized copper aesthetic - teal-green patina with copper accents",
    bg: "#E8F0F0", text: "#2A5A5A", gradient_color: "#E8F0F0",
    water: "#C0D8D8", parks: "#D8E8E0", buildings: "#D8E0E0",
    road_motorway: "#B87333", road_primary: "#5A8A8A",
    road_secondary: "#6B9E9E", road_tertiary: "#88B4B4",
    road_residential: "#A8CCCC"
  },
  pastel_bloom: {
    available: false,
    id: "pastel_bloom",
    name: "Pastel Bloom",
    description: "Soft muted pastels with dusty blues and mauves - dreamy artistic aesthetic",
    bg: "#FAF7F2", text: "#5D5A6D", gradient_color: "#FAF7F2",
    water: "#D4E4ED", parks: "#E8EDE4", buildings: "#E5E5E5",
    road_motorway: "#7B8794", road_primary: "#9BA4B0",
    road_secondary: "#B5AEBB", road_tertiary: "#C9C0C9",
    road_residential: "#D8D2D8"
  },
  prism_routes: {
    available: false,
    id: "prism_routes",
    name: "Prism Routes",
    description: "Smooth gradient from dark centre to light edges with subtle features",
    bg: "#FFFFFF", text: "#000000", gradient_color: "#FFFFFF",
    water: "#D5D5D5", parks: "#EFEFEF", buildings: "#E0E0E0",
    road_motorway: "#050505", road_primary: "#151515",
    road_secondary: "#2A2A2A", road_tertiary: "#404040",
    road_residential: "#555555"
  },
  pulse_contrast: {
    available: false,
    id: "pulse_contrast",
    name: "Pulse Contrast",
    description: "Strong contrast showing urban density",
    bg: "#FFFFFF", text: "#000000", gradient_color: "#FFFFFF",
    water: "#B0B0B0", parks: "#ECECEC", buildings: "#E0E0E0",
    road_motorway: "#000000", road_primary: "#0F0F0F",
    road_secondary: "#252525", road_tertiary: "#404040",
    road_residential: "#5A5A5A"
  },
  sandstone_calm: {
    id: "sandstone_calm",
    name: "Sandstone Calm",
    description: "Earthy warm neutrals with sepia tones - vintage map aesthetic",
    bg: "#F5F0E8", text: "#6B5B4F", gradient_color: "#F5F0E8",
    water: "#DDD5C8", parks: "#E8E4D8", buildings: "#E0DCD0",
    road_motorway: "#8B7355", road_primary: "#A08B70",
    road_secondary: "#B5A48E", road_tertiary: "#C9BBAA",
    road_residential: "#D9CFC2"
  },
  shadow_lines: {
    available: false,
    id: "shadow_lines",
    name: "Shadow Lines",
    description: "Pure black background with soft white/gray roads - modern gallery aesthetic",
    bg: "#020202", text: "#F5F5F5", gradient_color: "#000000",
    water: "#050505", parks: "#0A0A0A", buildings: "#1A1A1A",
    road_motorway: "#FFFFFF", road_primary: "#E5E5E5",
    road_secondary: "#BFBFBF", road_tertiary: "#8C8C8C",
    road_residential: "#5C5C5C"
  },
  soft_neutral: {
    id: "soft_neutral",
    name: "Soft Neutral",
    description: "Warm greyscale with gentle contrast - calm, interior-friendly modern neutral",
    bg: "#F3F0EA", text: "#2B2B2B", gradient_color: "#F3F0EA",
    water: "#D8E1E7", parks: "#E1E6D7", buildings: "#E0DCD4",
    road_motorway: "#2B2B2B", road_primary: "#4A4A4A",
    road_secondary: "#686868", road_tertiary: "#7E7E7E",
    road_residential: "#9A9A9A"
  },
  starlit_depth: {
    id: "starlit_depth",
    name: "Starlit Depth",
    description: "Deep navy background with rich gold roads - luxury atlas aesthetic",
    bg: "#071427", text: "#E3C96A", gradient_color: "#050F1E",
    water: "#030A16", parks: "#0D2133", buildings: "#122940",
    road_motorway: "#F0D98A", road_primary: "#E3C96A",
    road_secondary: "#C8A951", road_tertiary: "#A98845",
    road_residential: "#7E6640"
  },
  sumi_trace: {
    available: false,
    id: "sumi_trace",
    name: "Sumi Trace",
    description: "Traditional ink wash inspired - minimalist with subtle red accent",
    bg: "#FAF8F5", text: "#2C2C2C", gradient_color: "#FAF8F5",
    water: "#E8E4E0", parks: "#F0EDE8", buildings: "#E8E4E0",
    road_motorway: "#8B2500", road_primary: "#4A4A4A",
    road_secondary: "#6A6A6A", road_tertiary: "#909090",
    road_residential: "#B8B8B8"
  },
  tidal_lines: {
    available: false,
    id: "tidal_lines",
    name: "Tidal Lines",
    description: "Various blues and teals - perfect for coastal cities",
    bg: "#F0F8FA", text: "#1A5F7A", gradient_color: "#F0F8FA",
    water: "#B8D8E8", parks: "#D8EAE8", buildings: "#D8E8E8",
    road_motorway: "#1A5F7A", road_primary: "#2A7A9A",
    road_secondary: "#4A9AB8", road_tertiary: "#70B8D0",
    road_residential: "#A0D0E0"
  },
  tropical_dawn: {
    available: false,
    id: "tropical_dawn",
    name: "Tropical Dawn",
    description: "Warm coral and teal - sunset beach vibes for coastal memories",
    bg: "#FEF7F5", text: "#2D5A5A", gradient_color: "#FEF7F5",
    water: "#7EC8C8", parks: "#E8D5C4", buildings: "#F0E0D8",
    road_motorway: "#2D5A5A", road_primary: "#4A8080",
    road_secondary: "#6BA3A3", road_tertiary: "#8FC4C4",
    road_residential: "#B5D8D8"
  },
  vintage_atlas: {
    id: "vintage_atlas",
    name: "Vintage Atlas",
    description: "Aged paper + sepia inks - classic cartographic warmth with muted teal water",
    bg: "#F6EBD7", text: "#3B2F24", gradient_color: "#F6EBD7",
    water: "#A9C7C6", parks: "#C7D3B0", buildings: "#E8DCC8",
    road_motorway: "#3B2F24", road_primary: "#5A4636",
    road_secondary: "#715A45", road_tertiary: "#8A7056",
    road_residential: "#A3886A"
  },
  woodland_trace: {
    available: false,
    id: "woodland_trace",
    name: "Woodland Trace",
    description: "Deep greens and sage tones - organic botanical aesthetic",
    bg: "#F0F4F0", text: "#2D4A3E", gradient_color: "#F0F4F0",
    water: "#B8D4D4", parks: "#D4E8D4", buildings: "#D8E4D8",
    road_motorway: "#2D4A3E", road_primary: "#3D6B55",
    road_secondary: "#5A8A70", road_tertiary: "#7AAA90",
    road_residential: "#A0C8B0"
  }
};
